module.exports = __webpack_public_path__ + "img/4bdb9f076c1d35cb94e7fd11dd5e7e56.svg";